var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10419",
    "data-name": "Group 10419",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.358,
    height: 28.222,
    viewBox: "0 0 31.358 28.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2385",
    "data-name": "Rectangle 2385",
    width: 31.358,
    height: 28.222,
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10418",
    "data-name": "Group 10418",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29380",
    "data-name": "Path 29380",
    d: "M31.015,5.521A7.849,7.849,0,0,0,23.518,0H7.839a7.849,7.849,0,0,0-7.5,5.521A8.287,8.287,0,0,0,0,7.839V20.382a7.842,7.842,0,0,0,7.839,7.839H23.518a7.842,7.842,0,0,0,7.839-7.839V7.839a8.287,8.287,0,0,0-.343-2.318M7.839,3.136H23.518a4.716,4.716,0,0,1,4.639,3.953l-12.478,6.8L3.2,7.089A4.716,4.716,0,0,1,7.839,3.136M28.222,20.382a4.716,4.716,0,0,1-4.7,4.7H7.839a4.716,4.716,0,0,1-4.7-4.7v-9.75l11.793,6.426a1.579,1.579,0,0,0,1.5,0l11.793-6.426Z",
    transform: "translate(0)",
    fill: "#101b2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.3791b58ef12a6053911a9e7e4986f85e.svg";
export { ForwardRef as ReactComponent };